// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__Glpc3","spin":"styles_spin__9bYUx"};